import { render, staticRenderFns } from "./SetupProfilesPanel.vue?vue&type=template&id=29aef893&scoped=true"
import script from "./SetupProfilesPanel.vue?vue&type=script&lang=js"
export * from "./SetupProfilesPanel.vue?vue&type=script&lang=js"
import style0 from "./SetupProfilesPanel.vue?vue&type=style&index=0&id=29aef893&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aef893",
  null
  
)

export default component.exports